import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  style: {
    "background-color": "#f5f5f5"
  }
};
var _hoisted_2 = ["href"];
var _hoisted_3 = {
  class: "product_item"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "product_content"
};
var _hoisted_6 = {
  class: "title"
};
var _hoisted_7 = {
  class: "desc"
};
var _hoisted_8 = {
  class: "content"
};
var _hoisted_9 = {
  class: "value"
};

var _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "name"
}, "通用流量", -1);

var _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "sep_v"
}, null, -1);

var _hoisted_12 = {
  class: "value"
};

var _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "name"
}, "定向流量", -1);

var _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "sep_v"
}, null, -1);

var _hoisted_15 = {
  class: "value"
};

var _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "name"
}, "语音通话", -1);

var _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "sep_v"
}, null, -1);

var _hoisted_18 = {
  class: "value"
};

var _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  class: "name"
}, "月租", -1);

var _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "btn_div"
}, "立即办理", -1);

var _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "1rem"
  }
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.products, function (item, index) {
    return _openBlock(), _createElementBlock("a", {
      class: "product_div",
      key: 'products_' + index,
      href: $options.pageUrl(item),
      target: "_blank"
    }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
      src: item.imageUrl
    }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(item.detail), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_9, _toDisplayString(item.commonFlow) + " GB", 1), _hoisted_10]), _hoisted_11, _createElementVNode("div", null, [_createElementVNode("span", _hoisted_12, _toDisplayString(item.directFlow) + " GB", 1), _hoisted_13]), _hoisted_14, _createElementVNode("div", null, [_createElementVNode("span", _hoisted_15, _toDisplayString(item.minutes) + " 分钟", 1), _hoisted_16]), _hoisted_17, _createElementVNode("div", null, [_createElementVNode("span", _hoisted_18, _toDisplayString(item.monthFee) + " 元", 1), _hoisted_19])]), _hoisted_20])])], 8, _hoisted_2);
  }), 128)), _hoisted_21])]);
}